module.exports = __webpack_public_path__ + "static/media/hk.679d5ec3.svg";